import {
	CheckSquare,
	Clock,
	CurrencyCircleDollar,
	Notebook,
	ShieldCheck,
} from '@phosphor-icons/react';
import React from 'react';

const Step1 = () => {
	return (
		<div className='bg-white rounded-xl p-4 flex flex-col gap-6 relative'>
			<div className='flex flex-col justify-center md:items-center'>
				<Notebook
					weight='duotone'
					size={24}
					className='text-h-primary mb-2'
				/>
				<p className='font-medium text-lg'>
					Nueva regulación de plataformas tecnológicas
				</p>
				<p className='text-neutral-700 font-light md:text-center mt-2'>
					El gobierno nacional, el IMSS y el SAT, diseñaron una nueva ley para
					garantizar derechos laborales y seguridad social a trabajadores de
					plataformas digitales como tú. Fue aprobada en diciembre y{' '}
					<b className='font-bold underline'>
						entra en vigencia el 22 de junio.
					</b>
				</p>
			</div>

			<hr />

			<div className='mt-2'>
				<p className='font-medium text-base'>Beneficios para ti: </p>
				<div className='mt-3 flex flex-col gap-3'>
					{[
						{
							icon: <ShieldCheck />,
							title: 'Seguridad social',
							description:
								'Siempre tendrás protección contra accidentes y si generas más de $8.364 al mes con alguna plataforma tecnológica tendrás acceso a seguridad social (IMSS).',
						},
						{
							icon: <CurrencyCircleDollar />,
							title: 'Ingresos adicionales',
							description:
								'La ley contempla aguinaldo, vacaciones y participación en utilidades (PTU) si cumples un tiempo mínimo de trabajo en la plataforma.',
						},
						{
							icon: <Clock />,
							title: 'Flexibilidad',
							description:
								'Podrás seguir eligiendo tus horarios y para qué plataformas trabajar.',
						},
					]?.map((item, index) => {
						return (
							<div
								className='flex gap-2'
								key={index}
							>
								{React.cloneElement(item.icon, {
									className: 'text-h-primary min-w-5 min-h-5 mt-1',
									weight: 'bold',
								})}
								<div className='flex flex-col gap-1'>
									<p className='font-bold'>{item.title}</p>
									<p className='font-light'>{item.description}</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>

			<div className='bg-neutral-100/70 p-4 rounded-lg mt-3'>
				<p className='font-medium text-base'>Lo que debes hacer ahora:</p>
				<div className='mt-3 flex flex-col gap-3'>
					{[
						'Valida tu perfil de seguridad social: número de seguridad social, carné de seguridad social y datos completos del IMSS',
						'Verifica tu perfil fiscal: RFC, régimen fiscal correcto en tu constancia de situación fiscal, declaraciones al día con el SAT',
					]?.map((item, index) => {
						return (
							<div
								className='flex gap-2 font-light'
								key={index}
							>
								<CheckSquare
									weight='bold'
									size={24}
									className='text-green-600 min-w-5 min-h-5'
								/>
								{item}
							</div>
						);
					})}
				</div>
			</div>

			<div className='text-center w-full'>
				Te ayudamos a aprovechar estos beneficios y seguir trabajando en las
				plataformas sin contratiempos.
			</div>
		</div>
	);
};

export default Step1;
